// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { errorCodes, getAPIErrorMessage, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR, RESET } from './ForgotPasswordConstants'

const initialState = {
  error: '',
  resetSuccess: false,
  loading: false,
}

export const forgotPasswordReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        error: '',
        resetSuccess: false,
        loading: true,
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetSuccess: true,
        loading: false,
      }
    case RESET_PASSWORD_ERROR: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: getAPIErrorMessage(action.payload.ErrorCode),
        loading: false,
      }
    }
    case RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
